import { QueryClient } from "@tanstack/react-query";
import { createSyncStoragePersister } from "@tanstack/query-sync-storage-persister";
import { toast } from "react-toastify";
import { capitalize } from "lodash";

export const handleAPIError = (error: any, displayError = false) => {
  if (process.env.NODE_ENV !== "production") {
    console.log("Error: ", error);
  }
  if (error && Object.getOwnPropertyNames(error).includes("response")) {
    console.log("Display error: ", displayError);
    const message = error?.response?.data?.detail;
    console.log("message", message);

    if (displayError) {
      if (typeof message === "string") {
        console.log("message--", message);

        toast.error(capitalize(message), { autoClose: 3000 });
      } else {
        if (message && Array.isArray(message) && message.length) {
          console.log("message", message);
          //toast({ message: message[0], variant: "error" });
          toast.error(message[0], { autoClose: 3000 });
        }
      }
    }
    return message;
  }
};

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // cacheTime: Infinity,
      refetchOnWindowFocus: true,
      retry: false,
    },
  },
});

export const persister = createSyncStoragePersister({
  storage:
    typeof window !== "undefined" ? (window as any).localStorage : undefined,
});

export const readableDate = (date) => {
  return new Date(date).toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};

export const getStatusColor = (status: string) => {
  switch (status?.toLowerCase()) {
    case "pending":
      return "warning";
    case "draft":
      return "warning";
    case "paid":
      return "success";
    case "active":
      return "success";
    case "completed":
      return "success";
    case "failed":
      return "danger";
    case "approved":
      return "success";
    case "canceled":
      return "danger";
    case "in review":
      return "secondary";
    default:
      return "secondary";
  }
};

export const getErrorMessage = (error: any): string | undefined => {
  if (Array.isArray(error)) {
    return error[0]; // Return the first error message if it's an array
  }
  if (typeof error === "object" && error !== null) {
    return Object.values(error).join(", "); // Join multiple error messages if it's an object
  }
  return error as string; // Return the error as a string if it's already a string
};
